import { FetchItemsCardModelsByCatalogIdQueryType } from '@/redux/api/itemCardModel';
import type { ItemCardModel } from '@/types/ItemCardModel';
import type { TypedActionWithPayload } from '@/types/redux';

/* Action Types */
export const LOAD_CATALOG_ITEM_MODELS_FAIL = 'LOAD_CATALOG_ITEM_MODELS_FAIL';
export const LOAD_CATALOG_ITEM_MODELS_REQUEST = 'LOAD_CATALOG_ITEM_MODELS_REQUEST';

export const LOAD_CATALOG_ITEM_MODELS_SUCCESS = 'LOAD_CATALOG_ITEM_MODELS_SUCCESS';
export type LOAD_CATALOG_ITEM_MODELS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_CATALOG_ITEM_MODELS_SUCCESS,
    ItemCardModel[],
    {
        actionTime: number;
        catalogId: number;
        pageCount: number;
        query: FetchItemsCardModelsByCatalogIdQueryType;
        recordCount: number;
        totalRecords: number;
    }
>;
